import { IconFont } from '@/components/IconFont'
import { uploadAvatar, uploadFile } from '@/services/common/common.service'
import { Avatar, Space, Upload } from 'antd'
import ImgCrop from 'antd-img-crop'
import classnames from 'classnames'
import React, { memo, useEffect, useState } from 'react'
import OrbitAvatar from '../OrbitAvatar'
import styles from './index.module.less'

interface EditAvatarProps {
  value?: string
  onChange?: (value: string) => void
  colorPlacement?: string
  avatarSize?: number
  colorSize?: number
  name?: string
  metaData: {[key: string]: any}
}

const colors = ['#037C4B', '#FFB23F', '#FF653F', '#2CCFAF', '#D048BA']

export default memo<EditAvatarProps>(function EditAvatar(props) {
  const { value, onChange, name, avatarSize = 70, colorSize = 20, colorPlacement = 'bottom', metaData } = props
  const [avatar, setAvatar] = useState<string>(value || colors[0])

  useEffect(() => {
    if (!value) {
      onChange?.(colors[0])
    }
  }, [])

  const selectedColor = (color: string) => {
    setAvatar(color)
    onChange?.(color)
  }

  return (
    <div
      className={classnames(
        styles.container,
        { [styles.bottom]: colorPlacement === 'bottom' },
        { [styles.right]: colorPlacement === 'right' }
      )}
    >
      <div className={styles.avatar}>
        <OrbitAvatar avatar={avatar} size={avatarSize} name={name} />

        <ImgCrop cropShape={'round'} modalTitle={'Upload'}>
          <Upload
            customRequest={(data) => {
              const formData = new FormData()
              formData.append('file', data.file)
              Object.keys(metaData).forEach(key => {
                formData.append(key, metaData[key])
              })
              uploadAvatar(formData).then((data) => {

                const avatar = data?.url || 'http://dev.plant-orbit.com:8080/orbit2-web/api/users/avatar/2'
                setAvatar(avatar)
                onChange?.(avatar)
              })
            }}
            showUploadList={false}
            maxCount={1}
          >
            <IconFont type={'icon-edit'} />
          </Upload>
        </ImgCrop>
      </div>

      <Space className={styles.colors}>
        {colors.map((color) => (
          <span
            key={color}
            onClick={() => {
              selectedColor(color)
            }}
          >
            <Avatar size={colorSize} style={{ backgroundColor: color }} />
          </span>
        ))}
      </Space>
    </div>
  )
})
